import Image from "next/image";
import IMAGES from "@/public/assets/img";

const WhyCredlixSection = ({ HowItWorks }) => {
  return (
    <section
      className={`relative bg-no-repeat sm:bg-center bg-cover bg-bottom min-h-[400px] sm:min-h-[270px] py-sp-100 sm:py-sp-big`}
    >
      <Image
        priority={true}
        src={IMAGES.corporateLoan.howitworksBg}
        width={1366}
        height={550}
        className="absolute inset-0 max-w-none w-full h-full"
        alt="Banner Desktop"
      />
      <div className="container px-3 xm:px-2 relative">
        <h2
          className="text-center text-textxl font-medium mb-5 sm:text-lg"
          dangerouslySetInnerHTML={{ __html: HowItWorks.heading }}
        />
        <div className="flex flex-wrap gap-2 justify-between">
          {HowItWorks.whySection?.map((item) => (
            <div
              key={item.id}
              className="flex flex-col items-center text-center w-1/6 sm:w-[46%]"
            >
              <Image
                src={item.image}
                alt={item.text}
                width={120}
                height={120}
              />
              <p className="text-sm text-baseBlack">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyCredlixSection;
